import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LotIdResolver implements Resolve<number> {
  constructor() {}

  resolve(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    const urlSliceWithId = state.url.split('homes/').reverse()[0];
    const lotId = Number(urlSliceWithId.split('/')[0]);

    return lotId;
  }
}
